import React, {useState} from 'react';
import {Field, FieldArray, Form, Formik} from 'formik';
import AutoPersistToken from '../../elements/Formik/AutoPersistToken';
import PropTypes from 'prop-types';
import {Button, Col, Container, FormControl, FormLabel, InputGroup, Row} from 'react-bootstrap';
import useFormPersistedValues from '../../../hooks/useFormPersistedValues';
import AutoSubmitToken from '../../elements/Formik/AutoSubmitToken';
import {useGetCalculatorConfigQuery} from "../../../features/apiSlice.js";
import SelectField from "../../elements/ReactSelect/SelectField.jsx";
import {medicalExpensesOptions, periodTypeOptions} from "../../../utils.js";
import SwitchButton from "../../elements/Form/SwitchButton.jsx";
import Card from "../../elements/ReactBootstrap/Card.jsx";

const TravelAssistanceOfferWidget = ({
    autoSubmit,
    onSubmit,
    children,
}) => {
    const formName = 'travelAssistanceOfferForm';

    const formInitialValues = useFormPersistedValues(formName);

    const {
        data: calculatorConfig,
        isSuccess,
    } = useGetCalculatorConfigQuery();

    const [isMultiTrip, setIsMultiTrip] = useState(false);

    return (
        <Formik
            initialValues={formInitialValues || {
                personalNumber: '',
                destinationType: '',
                purposeType: '',
                medicalExpenses: '',
                isMultiTrip: isMultiTrip,
                insuredClientsPin: [],
                periodType: 0,
            }} validate={values => {
            const errors = {};
            if (values.personalNumber === '') {
                errors.personalNumber = 'Моля, въведете ЕГН/ЕИК на застраховащ';
            }
            if (!values.destinationType) {
                errors.destinationType = 'Моля, изберете дестинация';
            }
            if (values.periodType === 0) {
                errors.periodType = 'Моля, изберете период';
            }
            if (!values.purposeType) {
                errors.purposeType = 'Моля, изберете цел на пътуването';
            }
            if (!values.medicalExpenses) {
                errors.medicalExpenses = 'Моля, изберете медицински разноски'
            }
            if (values.insuredClientsPin.length < 1) {
                errors.medicalExpenses = 'Моля, въведете поне 1 застраховано лице'
            }
            return errors;
        }}
            onSubmit={onSubmit}
        >
            {({isSubmitting, values, setFieldValue}) => (
                <Container as={Form} className="gx-0">
                    <Card>
                    <Card header="Основни данни" collapse headerClassName='card-outline card-danger'>
                    <Row>
                        <Col>
                            <FormLabel htmlFor="isMultiTrip">Мултитрип</FormLabel>
                            <SwitchButton styleOn=" bg-teal" labelOn="Да" checked={false} name="isMultiTrip"
                                          onChange={checked => setIsMultiTrip(checked)}
                                          styleOff=" bg-indigo" labelOff="Не" disabled={isSubmitting}/>
                        </Col>
                    </Row>
                    <Row className="row-cols-1 row-cols-sm-2 row-cols-xl-4 g-3">
                        <Col>
                            <FormLabel htmlFor="periodType">Период</FormLabel>
                                {isMultiTrip ?
                                    <Field component={SelectField} name="periodType"
                                           options={periodTypeOptions}
                                           required disabled={isSubmitting} isClearable={true}
                                    />
                                    : <FormControl as={Field} type="number" name="periodType"
                                           id="periodType" required
                                           disabled={isSubmitting} min={1} max={100} />
                                }
                        </Col>
                        <Col>
                            <FormLabel htmlFor="personalNumber">ЕГН/ЕИК на застраховащ</FormLabel>
                            <InputGroup>
                                <InputGroup.Text>
                                    <i className="fas fa-user"/>
                                </InputGroup.Text>
                                <FormControl as={Field} type="text" name="personalNumber" id="personalNumber"
                                             required pattern="\d{9,13}" disabled={isSubmitting} maxLength={13}
                                             inputMode="decimal"/>
                            </InputGroup>
                        </Col>
                        <Col>
                            <FormLabel htmlFor="destinationType">Дестинация</FormLabel>
                            <Field component={SelectField} name="destinationType"
                                   options={isSuccess ? Object.entries(calculatorConfig.travelDestinations).map(
                                       ([code, description]) => ({
                                           label: description,
                                           value: code,
                                       })
                                   ) : []}
                                   required disabled={isSubmitting} isClearable={true}
                                   />
                        </Col>
                        <Col>
                            <FormLabel htmlFor="purposeType">Цел на пътуването</FormLabel>
                            <Field component={SelectField} name="purposeType"
                                   options={isSuccess ? Object.entries(calculatorConfig.travelPurposes)
                                       .filter(
                                           ([code, description]) => isMultiTrip ?
                                               code === 'WORK' || code === 'BUSINESS'
                                                : true
                                       )
                                       .map(
                                       ([code, description]) => ({
                                           label: description,
                                           value: code,
                                       })
                                   ) : []}
                                   required disabled={isSubmitting} isClearable={true}
                            />
                        </Col>
                        <Col>
                            <FormLabel htmlFor="medicalExpenses">Медицински разноски</FormLabel>
                            <Field component={SelectField} name="medicalExpenses"
                                   options={medicalExpensesOptions.filter(medicalExpensesOption =>
                                   isMultiTrip ? medicalExpensesOption.value >= 10000 : true)}
                                   required disabled={isSubmitting} isClearable={true}
                            />
                        </Col>
                        <FormControl as={FieldArray} name="insuredClientsPin"
                            render={arrayHelpers => (
                                <React.Fragment>
                                    <Col>
                                        <FormLabel htmlFor="insuredClientsPin">Застраховани лица</FormLabel>
                                        <Button variant="success" style={{display: 'flex'}}
                                                onClick={() => arrayHelpers.push("")}>
                                            <i className="fas fa-users"/>
                                        </Button>
                                    </Col>
                                    {values.insuredClientsPin && values.insuredClientsPin.length > 0 &&
                                        values.insuredClientsPin.map((insuredClientPin, index) => (
                                            <Col>
                                                <FormLabel htmlFor={`insuredClientsPin.${index}`}>{index+1}</FormLabel>
                                                <InputGroup key={index}>
                                                    <FormControl as={Field} name={`insuredClientsPin.${index}`}
                                                                 id={`insuredClientsPin.${index}`} type='text'
                                                                 required pattern="\d{10}"
                                                                 placeholder="въведете ЕГН"/>
                                                    <Button variant="outline-danger"
                                                            onClick={() => arrayHelpers.remove(index)}>
                                                        -
                                                    </Button>
                                                </InputGroup>
                                            </Col>
                                        )
                                    )}
                                </React.Fragment>
                            )}
                        />
                    </Row>
                    </Card>
                    {children}
                    <Row>
                        <Col className="align-self-end">
                            <Button variant="success" type="submit" className="w-100"
                                    onClick={() => setFieldValue("isMultiTrip", isMultiTrip)}
                                    disabled={isSubmitting}>
                                <i className="fas fa-search" /> Намери най-добрата оферта
                            </Button>
                        </Col>
                    </Row>
                    {autoSubmit && <AutoSubmitToken />}
                    <AutoPersistToken formName={formName}/>
                    </Card>
                </Container>

            )}
        </Formik>
    );
};

TravelAssistanceOfferWidget.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool,
    autoSubmit: PropTypes.bool,
};

TravelAssistanceOfferWidget.defaultProps = {
    autoFocus: false,
    autoSubmit: false,
};

export default TravelAssistanceOfferWidget;
